import {useEffect, useState} from 'react';
import {useLocation} from 'react-router';
import {ignoreLegacyIvwScript} from 'app/services/ivw/ivwLegacyHelpers';
import {callIvw, loadIvw} from 'app/services/ivw/ivw';
import {callIvwLegacy, loadIvwLegacyScript} from 'app/services/ivw/ivwLegacy';

const useIvw = partner => {
  const location = useLocation();
  const [ignoreLegacyIvw, setIgnoreLegacyIvw] = useState(true);
  const [ivwLegacyReady, setIvwLegacyReady] = useState(false);
  const [ivwReady, setIvwReady] = useState(false);

  useEffect(() => {
    const ignoreLegacy = ignoreLegacyIvwScript(partner.ivw);
    setIgnoreLegacyIvw(ignoreLegacy);
  }, [partner]);

  /* #### START LEGACY IVW #### */
  // Load legacy ivw script
  useEffect(() => {
    if (!ignoreLegacyIvw && (partner.ivw?.ivw_st_mobil || partner.ivw?.ivw_st_desktop)) {
      loadIvwLegacyScript(() => setIvwLegacyReady(true));
    }
  }, [partner, ignoreLegacyIvw]);

  // Call legacy ivw
  useEffect(() => {
    if (ivwLegacyReady && !ignoreLegacyIvw) {
      // Note: useEffect should only include mircotasks, no long task or blocking tasks
      // to prevent such effects caused by external script execution, function call is wrapped with timeout
      setTimeout(callIvwLegacy.bind(null, partner.ivw), 0);
    }
  }, [ivwLegacyReady, location, partner, ignoreLegacyIvw]);

  /* #### END LEGACY IVW #### */

  // Load ivw script
  useEffect(() => {
    if (
      (partner.ivw?.ivw_st_mobil && partner.ivw?.ivw_dns_mobil) ||
      (partner.ivw?.ivw_st_desktop && partner.ivw?.ivw_dns_desktop)
    ) {
      loadIvw(partner.ivw, () => setIvwReady(true));
    }
  }, [partner]);

  // Call ivw
  useEffect(() => {
    if (ivwReady) {
      // Note: useEffect should only include mircotasks, no long task or blocking tasks
      // to prevent such effects caused by external script execution, function call is wrapped with timeout
      setTimeout(callIvw.bind(null, partner.ivw, ignoreLegacyIvw), 0);
    }
  }, [ivwReady, location, partner, ignoreLegacyIvw]);
};

export default useIvw;
